import { http, ep } from "../../client/http";

export const pageConfigRepo = {
  getByPageKey: async (pageKey) => {
    const res = await http.get(ep(`pageConfig/${pageKey}`));
    return res.data.data; // sadece o sayfanın config'i
  },
};
